import { createStrictContext } from "../../js/react/hooks";
import {
  ContactFormResult,
  ContactRequest,
  OrderLookupResult,
  TicketType,
} from "./types";

export interface IContactFormContext {
  LookupOrder: (
    orderNumber: number,
    email: string,
    ticketId?: number
  ) => Promise<OrderLookupResult>;
  GetTicketTypes: () => Promise<Array<TicketType>>;
  SaveMessage: (request: ContactRequest) => Promise<ContactFormResult>;
}

export const [ContactFormContextProvider, useContactFormContext] =
  createStrictContext<IContactFormContext>();
